module.exports = "/services/podat-apellyatsiyu-na-rezultaty-gia/static/doc/rules.pdf";